export default __webpack_public_path__ + "static/1-dc4a28549aa8eccb3a59e240ad82ae21.png";